import { graphqlClient } from '@/lib/graphql-client';
import { buildGetEmployeesQuery, buildGetProjectsQuery } from '../graphql/queries';
import {
  DELETE_PROJECT_MUTATION,
  INSERT_PROJECT_MUTATION,
  UPDATE_PROJECT_MUTATION,
} from '../graphql/mutations';
import {
  EmployeesResult,
  GetProjectsParams,
  ProjectInsertInput,
  ProjectsPagingResult,
  ProjectUpdateInput,
} from '../types/project.types';

export const getProjects = async (
  params: GetProjectsParams
): Promise<{ Projects: ProjectsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetProjectsQuery(filter, pageNo, pageSize, order),
  });
};

export const getEmployees = async (keyword = ''): Promise<{ Employees: EmployeesResult }> => {
  const filter = keyword ? { DisplayName: { $regex: keyword, $options: 'i' } } : {};
  return graphqlClient.query({
    query: buildGetEmployeesQuery(filter, 1, 50),
  });
};

export const createProject = async (input: ProjectInsertInput) => {
  return graphqlClient.mutate({
    query: INSERT_PROJECT_MUTATION,
    variables: { input },
  });
};

export const updateProject = async (params: { itemId: string; input: ProjectUpdateInput }) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_PROJECT_MUTATION,
    variables: { filter, input: params.input },
  });
};

export const deleteProject = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_PROJECT_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
